import React, { ReactElement, ReactNode } from 'react'
import { orgStaticPageHeaderHeight } from 'components/NewStaticPage/StaticPageHeader'
import OrgStaticPage from 'components/Organization/HomePage/OrgStaticPage'
import { Flex } from 'theme-ui'

export default function LandingPageLayout({ children }: { children: ReactNode }): ReactElement {
  return (
    <OrgStaticPage hasMaxWidth={true} intraPageLinks={[{ text: 'Pricing', to: '/pricing' }]}>
      <Flex
        className="ios-scrolling-glitches-fix"
        sx={{
          width: '100%',
          height: '100%',
          flexDirection: 'column',
          alignItems: 'center',
          pt: ['4.2rem', '8rem'],
          pb: '8rem',
          '& [id]': {
            scrollMarginTop: orgStaticPageHeaderHeight,
          },
        }}
      >
        {children}
      </Flex>
    </OrgStaticPage>
  )
}
